export const applyFacilitator = ({ value, observation, breakLine }) => {
  if (!value) return observation;
  if (!observation) return value;

  if (breakLine) {
    observation += `\r\n${value}`;
  } else {
    observation += ` ${value}`;
  }

  return observation.trim();
};
